import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useState } from "react";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { useNavigate } from "react-router-dom";
import ChartSongsModal from "./ChartSongsModal";

const AddSongsToChartBulkAction = ({
  chartData,
  checkedKeys,
  setCheckedKeys,
  onAddSongs,
  onDeleteSongs,
  ...props
}: {
  chartData: any;
  checkedKeys: any;
  setCheckedKeys: Function;
  onAddSongs?: Function;
  onDeleteSongs?: Function;
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openModalByName, setOpenModalByName] = useState("");
  const ecryptedChartId = encryptUrl(`${chartData.id}`);

  const navigate = useNavigate();

  function backToCharts() {
    navigate(ContentRoutes.CHARTS);
  }

  function bulkAdd() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    onAddSongs && onAddSongs();
  }

  function bulkDelete() {
    setOpenModalByName("");
    onDeleteSongs && onDeleteSongs();
  }

  return (
    <div className="song-action col-md-6 song-action">
      {UtilityServices.hasPermission("delete-song") && (
        <>
          <Button onClick={bulkAdd}>
            {t("ADD")} {t("SONGS")}
          </Button>
          <Button onClick={backToCharts}>
            {t("BACK")} {t("TO")} {t("CHARTS")}
          </Button>
          <Button onClick={(e: any) => setOpenModalByName("show-chart-songs")}>
            {t("VIEW")} {t("CHART")} {t("SONGS")}
          </Button>
        </>
      )}
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={t("PLEASE_SELECT_RECORD_TO_ACTION")}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />
      {openModalByName === "show-chart-songs" && (
        <ChartSongsModal
          chartId={chartData?.id}
          chartData={chartData}
          openModal={openModalByName === "show-chart-songs" ? true : false}
          setOpenModal={setOpenModalByName}
          onDeleteSongs={bulkDelete}
          showPlayer={false}
        />
      )}
    </div>
  );
};

export default AddSongsToChartBulkAction;
